import { PriceMap } from './PriceMap';
import { CMC } from './CoinMarketCap';
import { Coin, CoinPriceMap, PriceFullRaw } from './Coin';
export class Portfolio {

  public holdings: Holding[] = [];
  public allCoins: CMC.AllCoins;
  public priceMap: CoinPriceMap = {};

  public priceMapO: PriceMap;

  constructor(holdings: Holding[], allCoins: CMC.AllCoins, priceMap: PriceMap){;
    this.holdings = holdings;
    if(!this.holdings) this.holdings = [];

    this.allCoins = allCoins;
    this.priceMapO = priceMap;

    this.priceMapO.addCoins(this.getCoinsArray());
  }

  public getCoinsArray(): Coin[]{
    let coins: Coin[] = [];
    // console.log(this.holdings);
    for(let holding of this.holdings){
      const name = holding.name
      let coin = this.getCoin(name);
      if(coin){
        coins.push(this.allCoins[name]);
      }
    }
    return coins;
  }

  public getHoldingValueByCoin(coin: Coin): number{
    let val = 0;
    let holding = this.getHoldingForCoin(coin);
    if(holding) val = holding.value;
    return val;
  }

  public getAssetValue(coin: Coin): number{
    if(this.priceMapO.getPrice(coin)){
      return this.priceMapO.getPrice(coin).PRICE * this.getHoldingValueByCoin(coin);
    }else{
      return 0;
    }
  }

  public getTotalValue(): number{
    let sum = 0;
    for(let coin of this.getCoinsArray()){
      sum += this.getAssetValue(coin);
    }
    return sum;
  }

  public getTotalPctChange(): number{
    let weights = 0; //value in currency, total value calculated
    let pctValue = 0;

    for(let coin of this.getCoinsArray()){
      let price = this.getCoinPrice(coin);
      if(!price) return -1;

      let pct = price.CHANGEPCT24HOUR;
      let coinValue = this.getAssetValue(coin);
      weights += coinValue;
      pctValue += pct * coinValue;
    }

    return pctValue/weights;
  }

  public getCoinPrice(coin: Coin): PriceFullRaw{
    return this.priceMapO.getPrice(coin);
  }

  public addCoin(coin: Coin){
    if(this.getHoldingForCoin(coin)) return; //check dups
    let newHolding = {
      name: coin.Symbol,
      value: 0
    };
    this.holdings.push(newHolding);
    // this.priceMapO.addCoins([coin]);
  }


  public removeCoin(coin: Coin){
    let holding = this.getHoldingForCoin(coin);
    let index = this.holdings.indexOf(holding);
    if(index != -1){
      this.holdings.splice(index, 1);
      this.priceMapO.removeCoins([coin]);
    }
  }

  public setHoldingsForCoin(coin: Coin, units: number){
    let holding = this.getHoldingForCoin(coin);

    if(holding){
      holding.value = units;
    }
  }

  public hasAssets(): boolean{
    return (this.holdings.length > 0);
  }

  public hasCoin(coin: Coin): boolean{

    if(this.getHoldingForCoin(coin)) return true;
    else return false;
  }

  public destroy(){
    this.priceMapO.removeCoins(this.getCoinsArray())
  }


  public getAllocations(): [Coin,number][]{
    let allocations = [];

    for(let coin of this.getCoinsArray()){
      let value = this.getAssetValue(coin);
      allocations.push([coin, value]);
    }

    return allocations;
  }

  private getHoldingForCoin(coin: Coin): Holding{
    let holding: Holding = null;
    for(let h of this.holdings){
      if(h.name == coin.Name) holding = h;
    }
    return holding;
  }

  private getCoin(name): any{
    let coin = null;
    coin = this.allCoins[name];
    if(!coin){
      let shortName = name.replace('$', '');
      coin = this.allCoins[shortName];
    } 
    return coin;
  }
}

export interface Holding{
  name: string;
  value: number;
}

export interface CoinPrice{
  coin: Coin;
  price: PriceFullRaw
}



// WEBPACK FOOTER //
// ./src/models/Portfolio.ts